import { Typography, alpha, styled } from "@mui/material";

import { Button } from "@citrine/atoms/button";
import { Column } from "@citrine/atoms/layout";

export const AgentList = styled(Column)(({ theme }) => ({
  alignSelf: "stretch",
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

interface AgentCardProps {
  isActive?: boolean;
}
// Selectable card built on the atoms Button (ButtonBase — ripple, focus-visible,
// keyboard), matching the search-space-type picker pattern.
// TODO: nearly identical to `Selection` in
// new-search-space-dialog.sx.ts — extract a shared selectable-card base (the
// only deltas are the `isActive` palette and `gap`) before a third copy appears.
export const AgentCard = styled(Column.withComponent(Button), {
  shouldForwardProp: (prop) => prop !== "isActive",
})<AgentCardProps>(({ isActive, theme }) => ({
  alignItems: "stretch",
  backgroundColor: isActive ? alpha(theme.palette.primary.main, 0.08) : "unset",
  borderColor: isActive ? theme.palette.primary.main : theme.palette.grey[300],
  borderRadius: theme.shape.borderRadiusMd,
  borderWidth: 2,
  color: theme.palette.text.primary,
  gap: theme.spacing(0.5),
  // Override the atoms Button's fixed height so the card grows to fit its
  // wrapping content instead of overflowing.
  height: "unset",
  padding: theme.spacing(1.5),
  textAlign: "left",
  // allow word wrap in button
  whiteSpace: "normal",

  "&:hover, &:focus": {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    borderColor: theme.palette.primary.main,
  },

  // only show shadow when hovered
  "&:not(:hover)": {
    boxShadow: "unset",
  },
}));

export const AgentName = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));

export const AgentExample = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontStyle: "italic",
}));
